(function() {
  'use strict';

  angular.module('component.goals', []);
})();
